/** Strings owned by the users area. */
export const USERS_STRINGS = {
    // ── Roles ──────────────────────────────────────────────────────────────────
    'users.role_superadmin': { en: 'Superadmin', ru: 'Суперадмин' },
    'users.role_admin': { en: 'Admin', ru: 'Админ' },
    'users.role_senior_operator': { en: 'Senior operator', ru: 'Старший оператор' },
    'users.role_operator': { en: 'Operator', ru: 'Оператор' },
    // ── Users page + tabs ──────────────────────────────────────────────────────
    'users.title': { en: 'Users', ru: 'Пользователи' },
    'users.tab_users': { en: 'Users', ru: 'Пользователи' },
    'users.tab_teams': { en: 'Teams', ru: 'Команды' },
    'users.tab_api': { en: 'API', ru: 'API' },
    // ── Users list ─────────────────────────────────────────────────────────────
    'users.add_user': { en: '+ Add user', ru: '+ Добавить пользователя' },
    'users.role': { en: 'Role', ru: 'Роль' },
    'users.login': { en: 'Login', ru: 'Логин' },
    'users.telegram': { en: 'Telegram', ru: 'Telegram' },
    'users.created': { en: 'Created', ru: 'Создан' },
    'users.active': { en: 'Active', ru: 'Активен' },
    'users.inactive': { en: 'Inactive', ru: 'Неактивен' },
    'users.no_users': { en: 'No users found', ru: 'Пользователи не найдены' },
    'users.failed_to_load_users': { en: 'Failed to load users', ru: 'Не удалось загрузить пользователей' },
    'users.network_error': { en: 'Network error', ru: 'Ошибка сети' },
    'users.delete_user_title': { en: 'Delete user', ru: 'Удалить пользователя' },
    'users.delete_user_confirm': {
        en: 'Are you sure you want to delete {login}?',
        ru: 'Удалить {login}?',
    },
    'users.failed_to_delete_user': { en: 'Failed to delete user', ru: 'Не удалось удалить пользователя' },
    // ── User form ──────────────────────────────────────────────────────────────
    'users.add_user_title': { en: 'Add user', ru: 'Добавить пользователя' },
    'users.edit_user_title': { en: 'Edit user', ru: 'Изменить пользователя' },
    'users.back_to_users': { en: '← Users', ru: '← Пользователи' },
    'users.edit_user_with_login': { en: 'Edit user — {login}', ru: 'Изменить пользователя — {login}' },
    'users.user_not_found': { en: 'User not found', ru: 'Пользователь не найден' },
    'users.login_placeholder': { en: 'username', ru: 'логин' },
    'users.password': { en: 'Password', ru: 'Пароль' },
    'users.confirm_password': { en: 'Confirm password', ru: 'Подтвердите пароль' },
    'users.new_password': { en: 'New password', ru: 'Новый пароль' },
    'users.new_password_hint': { en: '(leave blank to keep)', ru: '(оставьте пустым, чтобы не менять)' },
    'users.generate_password': { en: 'Generate password', ru: 'Сгенерировать пароль' },
    'users.copy_credentials': { en: '⎘ Copy credentials', ru: '⎘ Копировать доступы' },
    'users.set_login_password': { en: 'Set login & password', ru: 'Укажите логин и пароль' },
    'users.copied_check': { en: '✓ Copied', ru: '✓ Скопировано' },
    'users.password_generated': { en: '✓ Generated', ru: '✓ Сгенерирован' },
    'users.creating_share_link': { en: 'Creating link…', ru: 'Создаём ссылку…' },
    'users.share_link_failed': { en: 'Link service unavailable', ru: 'Сервис ссылок недоступен' },
    'users.credentials_block': {
        en: 'Login: {login}\nPassword (one-time link): {link}',
        ru: 'Логин: {login}\nПароль (одноразовая ссылка): {link}',
    },
    'users.credentials_link_note': {
        en: 'The link is one-time and valid for 1 day.',
        ru: 'Ссылка одноразовая и действует 1 день.',
    },
    'users.password_hidden_hint': {
        en: '(hidden — «Copy credentials» shares it as a one-time link)',
        ru: '(скрыт — «Копировать доступы» передаёт его одноразовой ссылкой)',
    },
    'users.new_password_resets_2fa': {
        en: 'A new password also resets 2FA — the user scans a new QR at next login.',
        ru: 'Новый пароль также сбрасывает 2FA — при следующем входе пользователь отсканирует новый QR.',
    },
    'users.tg_username': { en: 'Telegram username', ru: 'Telegram username' },
    'users.tg_username_hint': {
        en: '(optional — Clicker Bot tags this operator on cancel/decline payouts)',
        ru: '(необязательно — Clicker Bot упоминает оператора при отмене/отклонении выплат)',
    },
    'users.tg_username_placeholder': { en: '@username', ru: '@username' },
    'users.lock_role': { en: 'Lock role', ru: 'Заблокировать роль' },
    'users.select_team': { en: '— Select team —', ru: '— Выберите команду —' },
    'users.no_team': { en: '(no team)', ru: '(без команды)' },
    'users.team_required': { en: 'Team is required', ru: 'Команда обязательна' },
    'users.no_team_cannot_create': {
        en: 'You have no team — a user without a team cannot be created',
        ru: 'У вас нет команды — создать пользователя без команды нельзя',
    },
    'users.login_required': { en: 'Login is required', ru: 'Укажите логин' },
    'users.password_required': { en: 'Password is required', ru: 'Укажите пароль' },
    'users.passwords_mismatch': { en: 'Passwords do not match', ru: 'Пароли не совпадают' },
    'users.failed_to_create_user': { en: 'Failed to create user', ru: 'Не удалось создать пользователя' },
    'users.failed_to_update_user': { en: 'Failed to update user', ru: 'Не удалось обновить пользователя' },
    // ── Teams tab ──────────────────────────────────────────────────────────────
    'users.create_team_btn': { en: '+ Create team', ru: '+ Создать команду' },
    'users.no_teams': { en: 'No teams yet', ru: 'Команд пока нет' },
    'users.failed_to_load_teams': { en: 'Failed to load teams', ru: 'Не удалось загрузить команды' },
    'users.delete_team_title': { en: 'Delete team', ru: 'Удалить команду' },
    'users.delete_team_confirm': {
        en: 'Are you sure you want to delete {name}?',
        ru: 'Удалить {name}?',
    },
    'users.delete_team_soft_hint': {
        en: 'The team disappears from the lists and pickers and its API key stops working. Its users, farms, apps and flow assignments are kept — «Show deleted» brings it back.',
        ru: 'Команда исчезнет из списков и выборов, её API-ключ перестанет работать. Пользователи, фермы, приложения и назначенные флоу сохранятся — вернуть её можно через «Показывать удалённые».',
    },
    'users.failed_to_delete_team': { en: 'Failed to delete team', ru: 'Не удалось удалить команду' },
    'users.show_deleted_teams': { en: 'Show deleted', ru: 'Показывать удалённые' },
    'users.team_deleted_badge': { en: 'deleted', ru: 'удалена' },
    'users.restore_team': { en: 'Restore', ru: 'Восстановить' },
    'users.failed_to_restore_team': { en: 'Failed to restore team', ru: 'Не удалось восстановить команду' },
    'users.team_deleted_option': { en: '{name} (deleted)', ru: '{name} (удалена)' },
    // ── Team form ──────────────────────────────────────────────────────────────
    'users.create_team_title': { en: 'Create team', ru: 'Создать команду' },
    'users.edit_team_title': { en: 'Edit team', ru: 'Изменить команду' },
    'users.back_to_teams': { en: '← Teams', ru: '← Команды' },
    'users.edit_team_with_name': { en: 'Edit team — {name}', ru: 'Изменить команду — {name}' },
    'users.team_not_found': { en: 'Team not found', ru: 'Команда не найдена' },
    'users.team_name': { en: 'Team name', ru: 'Название команды' },
    'users.team_name_placeholder': { en: 'e.g. Team Alpha', ru: 'например, Team Alpha' },
    'users.team_name_required': { en: 'Team name is required', ru: 'Укажите название команды' },
    'users.team_name_too_long': {
        en: 'Team name must be 40 characters or fewer',
        ru: 'Название команды — не более 40 символов',
    },
    'users.failed_to_create_team': { en: 'Failed to create team', ru: 'Не удалось создать команду' },
    'users.failed_to_rename_team': { en: 'Failed to rename team', ru: 'Не удалось переименовать команду' },
    'users.team_close_shift': { en: 'Close shift', ru: 'Закрытие смены' },
    'users.team_close_shift_hint': {
        en: 'Show the «Close shift» button on the device cards of this team\'s farms',
        ru: 'Показывать кнопку «Закрыть смену» на карточках устройств ферм этой команды',
    },
    'users.failed_to_save_team': { en: 'Failed to save team', ru: 'Не удалось сохранить команду' },
    'users.clicker_app_availability': { en: 'Clicker app availability', ru: 'Доступные приложения кликера' },
    'users.clicker_app_availability_hint': {
        en: 'Tick the apps this team may use. Deposit / Payout is taken from the app catalog (Clicker → Apps). Leave everything unchecked to allow ALL apps (default).',
        ru: 'Отметьте приложения, доступные этой команде. Deposit / Payout берётся из каталога приложений (Кликер → Приложения). Оставьте всё пустым, чтобы разрешить ВСЕ приложения (по умолчанию).',
    },
    'users.no_clicker_apps': {
        en: 'No clicker apps in the catalog yet.',
        ru: 'В каталоге пока нет приложений кликера.',
    },
    'users.col_app': { en: 'App', ru: 'Приложение' },
    'users.col_supports': { en: 'Supports', ru: 'Поддерживает' },
    'users.col_available': { en: 'Available', ru: 'Доступно' },
    'users.deposit': { en: 'Deposit', ru: 'Депозит' },
    'users.payout': { en: 'Payout', ru: 'Выплата' },
    // ── Team API key ───────────────────────────────────────────────────────────
    'users.no_team_no_api_key': {
        en: 'You are not assigned to a team, so there is no API key to manage.',
        ru: 'Вы не состоите в команде, поэтому управлять API-ключом нечем.',
    },
    'users.failed_to_load_api_key': { en: 'Failed to load the API key', ru: 'Не удалось загрузить API-ключ' },
    'users.api_key_title': { en: 'Integration API key — {name}', ru: 'API-ключ интеграции — {name}' },
    'users.api_key_hint': {
        en: "A single key for the whole team. It authenticates external integrations against the API below and scopes them to this team's farms — anyone holding it can read this team's notifications registry, so treat it as a password.",
        ru: 'Один ключ на всю команду. Он аутентифицирует внешние интеграции в API ниже и ограничивает их фермами этой команды — любой, у кого есть ключ, может читать реестр уведомлений команды, поэтому обращайтесь с ним как с паролем.',
    },
    'users.api_key_not_set_hint': {
        en: 'No key is set, so the API is turned off for this team.',
        ru: 'Ключ не задан, поэтому API для этой команды выключен.',
    },
    'users.api_key_not_set': { en: 'Not set', ru: 'Не задан' },
    'users.copy_btn': { en: '⎘ Copy', ru: '⎘ Копировать' },
    'users.show': { en: 'Show', ru: 'Показать' },
    'users.hide': { en: 'Hide', ru: 'Скрыть' },
    'users.generate_new_key': { en: 'Generate new key', ru: 'Сгенерировать новый ключ' },
    'users.generate_key': { en: 'Generate key', ru: 'Сгенерировать ключ' },
    'users.generate': { en: 'Generate', ru: 'Сгенерировать' },
    'users.revoke': { en: 'Revoke', ru: 'Отозвать' },
    'users.confirm_generate_title': { en: 'Generate a new key', ru: 'Сгенерировать новый ключ' },
    'users.confirm_generate_text': {
        en: 'The current key for {name} stops working immediately. Every integration using it must be updated with the new key.',
        ru: 'Текущий ключ команды {name} перестанет работать сразу. Все интеграции, использующие его, нужно обновить на новый ключ.',
    },
    'users.confirm_revoke_title': { en: 'Revoke the API key', ru: 'Отозвать API-ключ' },
    'users.confirm_revoke_text': {
        en: 'The key for {name} stops working immediately and the API is turned off for this team until a new key is set.',
        ru: 'Ключ команды {name} перестанет работать сразу, и API для этой команды будет выключен, пока не задан новый ключ.',
    },
    'users.failed_to_save_key': { en: 'Failed to save the key', ru: 'Не удалось сохранить ключ' },
    // ── Team API — allowed IPs ─────────────────────────────────────────────────
    'users.allowed_ips': { en: 'Allowed IP addresses', ru: 'Разрешённые IP-адреса' },
    'users.allowed_ips_hint': {
        en: 'Restricts where the key above may be used from. While the list is empty the API accepts the key from any address; as soon as one entry is added, every other source is answered <code>403</code>. Single addresses (IPv4 or IPv6) and CIDR blocks are both accepted, e.g. <code>203.0.113.7</code> or <code>203.0.113.0/24</code>.',
        ru: 'Ограничивает, откуда можно использовать ключ выше. Пока список пуст, API принимает ключ с любого адреса; как только добавлена хотя бы одна запись, всем остальным источникам возвращается <code>403</code>. Принимаются как отдельные адреса (IPv4 или IPv6), так и CIDR-блоки, например <code>203.0.113.7</code> или <code>203.0.113.0/24</code>.',
    },
    'users.add_ip_label': { en: 'Add address or block', ru: 'Добавить адрес или блок' },
    'users.ip_placeholder': { en: 'e.g. 203.0.113.7', ru: 'например, 203.0.113.7' },
    'users.ips_empty': {
        en: 'Empty — the key is accepted from any address.',
        ru: 'Пусто — ключ принимается с любого адреса.',
    },
    'users.invalid_ip': { en: 'Invalid address or block: {value}', ru: 'Неверный адрес или блок: {value}' },
    'users.saved_no_ip_restriction': { en: 'Saved — no IP restriction', ru: 'Сохранено — без ограничения по IP' },
    // ── Team API — endpoint docs ───────────────────────────────────────────────
    'users.api_docs_title': { en: 'API — notifications registry', ru: 'API — реестр уведомлений' },
    'users.api_docs_intro': {
        en: 'Returns every notification (a finalized deposit or payout reported by the clicker) for the farms of the team the key belongs to, grouped into a map keyed by farm id. Each entry carries the farm name and its list of operations.',
        ru: 'Возвращает все уведомления (завершённые депозиты и выплаты, о которых отчитался кликер) по фермам команды, которой принадлежит ключ, сгруппированные в объект с ключом — id фермы. В каждой записи название фермы и список её операций.',
    },
    'users.api_docs_endpoint': { en: 'Endpoint', ru: 'Endpoint' },
    'users.api_docs_auth': { en: 'Authentication', ru: 'Аутентификация' },
    'users.api_docs_auth_text': {
        en: 'the team API key above, in either header:',
        ru: 'API-ключ команды выше, в одном из заголовков:',
    },
    'users.api_docs_401': {
        en: 'An unknown, missing or revoked key answers <code>401</code>. No panel session or cookie is involved.',
        ru: 'На неизвестный, отсутствующий или отозванный ключ возвращается <code>401</code>. Сессия панели и cookie не используются.',
    },
    'users.api_docs_403': {
        en: 'If the team has allowed IP addresses configured above, a call from any other source answers <code>403</code> — the error names the address the panel saw, which is the value to add to the list.',
        ru: 'Если у команды заданы разрешённые IP-адреса выше, на запрос с любого другого источника возвращается <code>403</code> — в ошибке указан адрес, который увидела панель, его и нужно добавить в список.',
    },
    'users.api_docs_query_params': { en: 'Query parameters', ru: 'Параметры запроса' },
    'users.api_docs_period': {
        en: '<code>period</code> — <code>day</code> (last 24 hours, the default) or <code>week</code> (last 7 days). Anything else answers <code>400</code>.',
        ru: '<code>period</code> — <code>day</code> (последние 24 часа, по умолчанию) или <code>week</code> (последние 7 дней). На любое другое значение возвращается <code>400</code>.',
    },
    'users.api_docs_screenshots': {
        en: '<code>screenshots</code> — <code>1</code> to inline the failure screen of every operation that has one, as base64. Off by default: the pictures are far larger than the rest of the payload.',
        ru: '<code>screenshots</code> — <code>1</code>, чтобы вложить экран сбоя каждой операции, у которой он есть, в виде base64. По умолчанию выключено: картинки в разы тяжелее остального ответа.',
    },
    'users.api_docs_screenshots_note': {
        en: 'With <code>screenshots=1</code> each operation additionally carries <code>screenshot_base64</code> and <code>screenshot_mime</code> (<code>image/jpeg</code> or <code>image/png</code>); both are <code>null</code> when the file is already gone. A response caps the inlined pictures at 32 MB and reports <code>screenshots_truncated</code> when the newest ones used it up.',
        ru: 'При <code>screenshots=1</code> в каждой операции дополнительно приходят <code>screenshot_base64</code> и <code>screenshot_mime</code> (<code>image/jpeg</code> или <code>image/png</code>); оба <code>null</code>, если файла уже нет. В одном ответе вложенных картинок не больше 32 МБ, и при исчерпании лимита возвращается <code>screenshots_truncated</code>.',
    },
    'users.api_docs_example': { en: 'Example', ru: 'Пример' },
    'users.api_docs_response': { en: 'Response', ru: 'Ответ' },
    'users.api_docs_fields': { en: 'Fields', ru: 'Поля' },
    'users.api_docs_field_farms': {
        en: '<code>farms</code> — the registry itself: farm id (as a string key) → <code>{ id, name, operations }</code>. Every farm of the team is present, including farms with no operations in the window (empty list).',
        ru: '<code>farms</code> — сам реестр: id фермы (строковым ключом) → <code>{ id, name, operations }</code>. Присутствуют все фермы команды, включая фермы без операций за период (пустой список).',
    },
    'users.api_docs_field_udid': {
        en: '<code>udid</code> — the device that ran the operation; <code>tx_id</code> — the platform transaction id (empty for apps that expose none).',
        ru: '<code>udid</code> — устройство, выполнившее операцию; <code>tx_id</code> — id транзакции платформы (пусто для приложений, которые его не отдают).',
    },
    'users.api_docs_field_task_type': {
        en: '<code>task_type</code> — <code>deposit</code>, <code>merchant_payout</code> or <code>external_payout</code>.',
        ru: '<code>task_type</code> — <code>deposit</code>, <code>merchant_payout</code> или <code>external_payout</code>.',
    },
    'users.api_docs_field_operator': {
        en: '<code>operator_login</code> — the panel login of the operator whose clicker run produced the operation, i.e. who was working the device at that moment. Empty when nobody was on record: an automatic resume, a start from the phone itself, or a start older than the run log keeps.',
        ru: '<code>operator_login</code> — логин в панели того оператора, чей запуск кликера сделал операцию, то есть кто работал на устройстве в этот момент. Пусто, если на учёте никого не было: авто-resume, старт с самого телефона или запуск старше, чем хранится лог запусков.',
    },
    'users.api_docs_field_synced': {
        en: '<code>platform_synced</code> / <code>tg_synced</code> — whether the operation reached the platform callback and Telegram. <code>null</code> when it does not apply (deposits have no per-operation Telegram message).',
        ru: '<code>platform_synced</code> / <code>tg_synced</code> — дошла ли операция до колбэка платформы и до Telegram. <code>null</code>, когда неприменимо (у депозитов нет отдельного сообщения в Telegram).',
    },
    'users.api_docs_field_total': {
        en: '<code>total</code> / <code>truncated</code> — the number of operations returned and whether the 50 000-row cap was hit.',
        ru: '<code>total</code> / <code>truncated</code> — сколько операций возвращено и был ли достигнут лимит в 50 000 строк.',
    },
    'users.api_docs_field_screenshot': {
        en: '<code>has_screenshot</code> — whether a failure screen was stored for the operation. Only non-successes get one, and it is pruned together with the operation.',
        ru: '<code>has_screenshot</code> — сохранён ли для операции экран сбоя. Он бывает только у неуспешных операций и удаляется вместе с самой операцией.',
    },
    'users.api_docs_field_from_to': {
        en: '<code>from</code> / <code>to</code> — the window actually queried, ISO-8601 UTC.',
        ru: '<code>from</code> / <code>to</code> — фактически запрошенный период, ISO-8601 UTC.',
    },
    'users.api_docs_retention': {
        en: 'Operations are kept for 14 days; <code>week</code> is still the longest window this endpoint offers.',
        ru: 'Операции хранятся 14 дней; <code>week</code> — по-прежнему самый длинный период, который отдаёт этот эндпоинт.',
    },
};
